import { store } from "@/store/index.js";
import router from "../router";

const ROOT_PAGE_SIGNAL = 1;
const TASK_SUMMARY_ROUTES = [
  "task-summary",
  "task-summary-user-agent",
  "task-summary-user-agents",

  'task-summary-all-user-agent',
  'task-summary-all-user-all-agents',
];

export default {
  dispatchScGuidanceBroadcast(params) {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA)) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA,
        payload: {
          scorecard_id: params.scorecard_id,
          agent_id: params.agent_id
        },
        refreshRootPage:
          !TASK_SUMMARY_ROUTES.includes(router.currentRoute.name) &&
          params.refresh_root &&
          params.agent_id != 0
      });
    }
  },
  dispatchScAdjustmentBroadcast() {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA)) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA,
        payload: null,
        refreshRootPage: false
      });
    }
  },
  dispatchTaskSummBroadcast() {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA)) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA,
        payload: null
      });
    }
  },
  dispatchGuidanceSessBroadcast(params) {
    if (
      this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA)
    ) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA,
        payload: params,
        refreshRootPage: true
      });
    }
  },
  dispatchScTaskRefreshBroadcast() {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA)) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA,
        payload: null
      });
    }
  },
  dispatchScCallTaskBroadcast() {
    if (
      this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_SC_CALL_TASK_LIST_DATA)
    ) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_SC_CALL_TASK_LIST_DATA,
        payload: null
      });
    }
  },
  dispatchTaskSummListBroadcast() {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_TASK_SUMM_LIST_DATA)) {
      store.dispatch("broadcast/createBroadcastAction", {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_TASK_SUMM_LIST_DATA,
        payload: null
      });
    }
  },
  dispatchTaskSummDateRangeChangeBroadcast(payload) {
    if (this.broadcastHasNoAction(process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE)) {
      let newpayload = {
        signal: ROOT_PAGE_SIGNAL,
        action: process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE,
        payload
      }
      store.dispatch("broadcast/createBroadcastAction", newpayload);
    }
  },

  broadcastHasNoAction(action) {
    let broadcastActionList = store.state.broadcast.broadcastActionList;
    return broadcastActionList.findIndex(item => item.action == action) < 0;
  }
};
